export default {"src":"/_next/static/media/insta.8f9d40fb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};